import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  height: fit-content;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
  border-radius: 24px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2rem;
  .personal-stats {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .personal-stats-element {
      text-align: center;
      .up-arrow {
        display: flex;
        align-items: center;
        &::after {
          content: "";
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-bottom: 7px solid green;
        }
      }
      .down-arrow {
        display: flex;
        align-items: center;
        &::after {
          content: "";
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid #f00;
        }
      }
      .stat-value {
        font-weight: 700;
      }
    }
  }
  .secondary-personal-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    h2 {
      font-size: 3rem;
      margin: 0 auto;
    }
  }
  @media only screen and (min-width: 867px) {
    height: ${(props) => (props.isDnD ? "calc(100% - 2rem)" : "40vh")};
    max-width: ${(props) => (props.isDnD ? "100%" : "30%")};
    width: ${(props) => (props.isDnD ? "calc(100% - 2rem)" : "30%")};
    margin-bottom: 0;
  }
`;
